<template>
  <div class="root-box">
    <el-tabs v-model="activeTab">
      <el-tab-pane label="活动管理" name="campaign">
        <wecom-campaign></wecom-campaign>
      </el-tab-pane>
      <el-tab-pane label="二维码生成" name="contactWayState">
        <wecom-contact-way-state></wecom-contact-way-state>
      </el-tab-pane>
      <el-tab-pane label="微信小程序链接" name="wxmpLink">
        <wecom-wxmp-link></wecom-wxmp-link>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import WecomCampaign from "./campagin.vue";
import WecomContactWayState from "./contactWayState.vue";
import WecomWxmpLink from "./wxmpLink.vue";

export default {
  components: {
    WecomCampaign,
    WecomContactWayState,
    WecomWxmpLink
  },
  data() {
    return {
      activeTab: "campaign"
    };
  }
};
</script>

<style scoped>
.root-box {
  padding: 0 10px;
}
</style>
